import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { cn } from "../../../utils";
/**
 * Empty state component for DataTable.
 * Displays a message when no data is available.
 *
 * @example
 * ```tsx
 * <DataTableEmpty message="No results found." />
 * ```
 */ export function DataTableEmpty({ message, className }) {
    const { t } = useTranslation();
    const displayMessage = message || t("dataTable.noResultsFound");
    return /*#__PURE__*/ _jsx("div", {
        className: cn("flex h-64 items-center justify-center rounded-md border border-dashed", className),
        children: /*#__PURE__*/ _jsx("div", {
            className: "flex flex-col items-center gap-1 text-center",
            children: /*#__PURE__*/ _jsx("h3", {
                className: "text-lg font-medium tracking-tight text-muted-foreground",
                children: displayMessage
            })
        })
    });
}

//# sourceMappingURL=DataTableEmpty.js.map